import React from 'react';
import PageDescription from "../components/baseComponents/head/pageDescription/PageDescription";
import {getAnalytics, getPageData} from "../api/app";
import ContentPage from "../components/contentPage/ContentPage";
import {createMetaData} from "../utils/data/createMetaData";
import Head from "next/head";
import {NEXT_PUBLIC_BASE_URL} from "../constants/copyright";
import {getItemListMicrodata, getOrganizationMicrodata} from "../utils/data/getMicrodata";


export default function Home({data}) {
  const {settings, content} = data || {};
  const canonicalUrl = `${NEXT_PUBLIC_BASE_URL}`;
  const organizationMicrodata = getOrganizationMicrodata();
  const itemListMicrodata = getItemListMicrodata(content?.items || []);

  return (
    <>
      <Head>
        <link rel="canonical" href={canonicalUrl}/>
        <meta name={'menuCategory'} content={''}/>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{__html: JSON.stringify(organizationMicrodata)}}
        />
        {itemListMicrodata.numberOfItems > 0 && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{__html: JSON.stringify(itemListMicrodata)}}
          />
        )}
      </Head>
      <div className="container">
        <PageDescription
          {...createMetaData(
            settings?.title,
            settings?.description,
            settings?.share_image,
            null,
            null,
            canonicalUrl,
            'website'
          )}
        />
        <ContentPage data={data}/>
      </div>
    </>
  );
}

export async function getStaticProps() {
  let data = null;
  let analytic = null;
  let hasError = false;

  console.log(`${new Date().toLocaleString()} [index] START`);

  const results = await Promise.all([
    (async () => {
      try {
        console.log(`${new Date().toLocaleString()} [index] getPageData:start`);
        const res = await getPageData();
        console.log(`${new Date().toLocaleString()} [index] getPageData:done`);
        return res;
      } catch (e) {
        hasError = true;
        console.error(
          `${new Date().toLocaleString()} [index] getPageData:error`,
          e
        );
        return null;
      }
    })(),
    (async () => {
      try {
        console.log(`${new Date().toLocaleString()} [index] getAnalytics:start`);
        const res = await getAnalytics();
        console.log(`${new Date().toLocaleString()} [index] getAnalytics:done`);
        return res;
      } catch (e) {
        hasError = true;
        console.error(
          `${new Date().toLocaleString()} [index] getAnalytics:error`,
          e
        );
        return null;
      }
    })(),
  ]);

  [data, analytic] = results;

  console.log(`${new Date().toLocaleString()} [index] COMPLETE`);

  return {
    props: {
      data,
      analytic,
      hasError,
    },
    revalidate: 10,
  };
}
